<script setup>
import { ref, watchEffect } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const auth = useAuthStore();
const router = useRouter();

const email = ref('');
const password = ref('');

watchEffect(() => {
  if (auth.ui.prefillEmail) email.value = auth.ui.prefillEmail;
});

async function onSubmit() {
  const ok = await auth.login(email.value, password.value);
  if (!ok) return;
  await auth.fetchAccessMe();
  const target = auth.ui.loginRedirect;
  auth.hideLogin();
  if (target) router.push(target);
}
</script>

<template>
  <div
      v-if="auth.ui.loginVisible"
      id="login-modal"
      role="dialog"
      aria-modal="true"
      class="fixed inset-0 z-[1000] flex items-center justify-center p-4"
  >
    <div class="absolute inset-0 bg-black/60 backdrop-blur-sm" @click="auth.hideLogin()" />
    <div class="relative bg-orange-50 w-full max-w-sm rounded-xl shadow-2xl overflow-hidden">
      <!-- Header (same style as SubscriptionModal) -->
      <div class="bg-blue text-white px-6 py-4 flex items-center justify-between">
        <h2 class="text-lg font-bold">{{ auth.ui.loginTitle }}</h2>
        <button class="text-white/80 hover:text-white text-2xl leading-none cursor-pointer" @click="auth.hideLogin()">&times;</button>
      </div>

      <div class="p-5">
        <form class="space-y-4" @submit.prevent="onSubmit">
          <div>
            <label class="block text-sm font-medium text-blue mb-1">E-Mail</label>
            <input v-model="email" type="email" required class="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue" />
          </div>

          <div>
            <label class="block text-sm font-medium text-blue mb-1">Passwort</label>
            <input v-model="password" type="password" required class="w-full border border-gray-300 rounded-lg px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue" />
          </div>

          <p v-if="auth.error" class="text-red-600 text-sm">{{ auth.error }}</p>

          <button type="submit" class="btn-primary w-full py-3" :disabled="auth.loading">
            {{ auth.loading ? 'Bitte warten…' : 'Einloggen' }}
          </button>
        </form>
      </div>
    </div>
  </div>
</template>
